<div class="account-section">
  <div class="my-section-box">
    <form [formGroup]="incidentform">
      <div class="my-section-box__headline">{{'dataExtractionRquest.incidentInformation'|cxTranslate}}
      </div>
      <div class="data-extraction__form">
        <div class="my-section-box-inner">
          <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <label
              class="label-title">{{'IncidentForm.label_Is_this_Request_the_Result_of_an_Accident'|cxTranslate}}</label>

              <div class="square-radio-group">

                <label class="square-radio">
                  <input type="radio" formControlName="accidentResult" value="yes" />
                  <span class="custom-square"></span>
                  {{'IncidentForm.Yes'|cxTranslate}}
                </label>

                <label class="square-radio">
                  <input type="radio" formControlName="accidentResult" value="no" />
                  <span class="custom-square"></span>
                  {{'IncidentForm.No'|cxTranslate}}
                </label>

              </div>
            </div>
          </div>

          <div class="row margin-top-25">
            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
              <label for="incidentDate"
              class="control-label">{{'IncidentForm.Date_of_Incident'|cxTranslate}}</label>
              <input class="form-control bsdpicker kb-datePickerIcon" bsDatepicker
                formControlName="incidentDate" placeholder="{{'IncidentForm.Select_Date'|cxTranslate}}"
                                [ngClass]="{ 'is-valid': (incidentform?.get('incidentDate').dirty  ) && !incidentform?.get('incidentDate')?.errors, 
                                'is-invalid': (incidentform?.get('incidentDate').dirty  ) && incidentform?.get('incidentDate')?.errors }"
                [bsConfig]="{ dateInputFormat:'MM/DD/YYYY',showWeekNumbers:false, displayOneMonthRange: true }">
                <div class="invalid-feedback">
                  @if ( incidentform?.get('incidentDate')?.errors && incidentform?.get('incidentDate')?.errors['required']) {
                    <span class="text-danger-show"
                    >{{'dataExtractionRquest.error_message'|cxTranslate}}</span>
                  }
                </div>
              </div>
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                <label for="incidentTime"
                class="control-label">{{'IncidentForm.Time_of_Incident'|cxTranslate}}</label>
                <input type="time" formControlName="incidentTime" class="form-control" name="incidentTime"
                                [ngClass]="{ 'is-valid': (incidentform?.get('incidentTime').dirty  ) && !incidentform?.get('incidentTime')?.errors, 
                                    'is-invalid': (incidentform?.get('incidentTime').dirty  ) && incidentform?.get('incidentTime')?.errors }">
                  <div class="invalid-feedback">
                    @if ( incidentform?.get('incidentTime')?.errors && incidentform?.get('incidentTime')?.errors['required']) {
                      <span class="text-danger-show"
                      >{{'dataExtractionRquest.error_message'|cxTranslate}}</span>
                    }
                  </div>
                </div>
              </div>
              <div class="row margin-top-25">
                <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                  <label for="city"
                  class="control-label">{{'IncidentForm.City_of_Incident'|cxTranslate}}</label>
                  <input type="text" formControlName="city" class="form-control" name="city"
                                [ngClass]="{ 'is-valid': (incidentform?.get('city').dirty  ) && !incidentform?.get('city')?.errors, 
                                    'is-invalid': (incidentform?.get('city').dirty  ) && incidentform?.get('city')?.errors }">
                    <div class="invalid-feedback">
                      @if ( incidentform?.get('city')?.errors && incidentform?.get('city')?.errors['required']) {
                        <span class="text-danger-show"
                        >{{'dataExtractionRquest.error_message'|cxTranslate}}</span>
                      }
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                    <label for="state"
                    class="control-label">{{'IncidentForm.State_of_Incident'|cxTranslate}}</label>
                    <div class="select-box">
                      <select name="state" class="form-control" formControlName="state"
                                    [ngClass]="{ 'is-valid': (incidentform?.get('state').dirty  ) && !incidentform?.get('state')?.errors, 
                                                    'is-invalid': (incidentform?.get('state').dirty  ) && incidentform?.get('state')?.errors }">
                        <option [ngValue]="null" disabled selected>
                        {{'IncidentForm.Select_Your_State'|cxTranslate}}</option>
                        @for (item of stateList?.regionsWSList; track item) {
                          <option [ngValue]="item.isocode">
                          {{item.name}}</option>
                        }
                      </select>
                      <div class="invalid-feedback">
                        @if ( incidentform?.get('state')?.errors && incidentform?.get('state')?.errors['required']) {
                          <span class="text-danger-show"
                            >
                            <span>{{'dataExtractionRquest.error_message'|cxTranslate}}</span>
                          </span>
                        }
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row margin-top-25">
                  <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                    @if ((pageFieldData$|async); as pageFieldData) {
                      <label for="country"
                      class="control-label">{{'IncidentForm.Country_of_Incident'|cxTranslate}}</label>
                      <div class="select-box">
                        <select name="country" class="form-control" formControlName="country"
                          (change)="onCountryChange($event)"
                          [ngClass]="{ 'is-valid': (incidentform?.get('country')?.dirty  ) && !incidentform?.get('country')?.errors, 'is-invalid': (incidentform?.get('country').dirty  ) && incidentform?.get('country')?.errors }">
                          <option [ngValue]="null" disabled selected>
                          {{'IncidentForm.Select_Your_Country'|cxTranslate}}</option>
                          @for (item of pageFieldData['countriesWSList']; track item) {
                            <option
                              [ngValue]="item.isocode">
                              {{item.name}}
                            </option>
                          }
                        </select>
                        <div class="invalid-feedback">
                          @if ( incidentform?.get('country')?.errors && incidentform?.get('country')?.errors['required']) {
                            <span class="text-danger-show"
                            >{{'dataExtractionRquest.error_message'|cxTranslate}}</span>
                          }
                        </div>
                      </div>
                    }
                  </div>
                </div>
                <div class="endsure-btnblock">
                  <button class="btn-action btn-back mt-4" (click)="back()">
                    <img src="/icons/link_left_white.svg" class="next-icon-right default-icon" alt="Back">
                  {{ 'dataExtractionRquest.back' | cxTranslate }}</button>

                  <button class="btn-action btn-next mt-4" [disabled]="!allowNext"
                    (click)="next()">{{'dataExtractionRquest.Next'|cxTranslate}}
                    <img src="/icons/link-white.svg" class="next-icon-right default-icon" alt="Next">
                  </button>

                </div>

              </div>
            </div>
          </form>
        </div>
      </div>